import {
    get,
    GetReturnType,
    post,
    put,
    remove,
    Type_RequestConfig,
} from "src/api/fetch";
import { getSchemaFromUrl } from "src/router/routes";
import { Type_User } from "src/types/user";

export const getAllUsers = (token: string): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/users`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const createUser = (
    body: Omit<Type_User, "id">,
    token: string,
): GetReturnType => {
    return post(body, `${VITE_API_URL}/${getSchemaFromUrl()}/users`, {
        Authorization: `Bearer ${token}`,
    } as Type_RequestConfig);
};

export const deleteUser = (id: number, token: string): GetReturnType => {
    return remove(`${VITE_API_URL}/${getSchemaFromUrl()}/users/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const updateUser = (
    id: number,
    body: Partial<Type_User>,
    token: string,
): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }

    return put(body, `${VITE_API_URL}/${getSchemaFromUrl()}/users/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
